import {DataTable} from '@management-ui/core';
import * as React from 'react';
import {useCallback, useContext, useMemo} from 'react';
import {ServiceContext} from '../../../../components/Services';
import UserForm from '../../forms/UserForm';
import {useHistory} from 'react-router-dom';
import {reverse} from 'named-urls';
import routes from '../../../../routes';

const Table = ({archive = false}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();

  const goToDetail = useCallback((user) => {
    history.push(reverse(`${archive ? routes.archive.administrators.detail : routes.administrators.detail}`, {id: user.id}));
  }, [history, archive]);

  return (
    <DataTable
      title="Administrators"
      columns={useMemo(() => [
        {title: 'Name', field: 'name', render: data => `${data.first_name} ${data.last_name}`},
        {title: 'Email', field: 'email'},
        {title: 'Has Engineer Access?', field: 'is_engineer', lookup: {true: 'Yes', false: 'No'}},
        {title: 'Is superuser?', field: 'is_superuser', lookup: {true: 'Yes', false: 'No'}},
        {title: 'Active?', field: 'is_active', lookup: {true: 'Yes', false: 'No'}},
      ], [])}
      loadData={query => new Promise((resolve, reject) => {
        services.user.getTableUsers(query, {admins: '1'})
          .then(response => {
            resolve({
              data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
            });
          }).catch(() => {
          reject();
        });
      })}
      onRowClick={goToDetail}
      newForm={{
        title: 'Add New Administrator',
        render: (props) => <UserForm user={{}} admin={true} {...props}/>,
        onSaved: goToDetail
      }}
    />
  );
}

export default Table;